import { event, trackCTAClick, trackVideoPlay, trackScrollDepth, trackFormSubmit } from '../config/gtag';

// Función general para tracking de eventos
export const trackEvent = (action, category, label, value) => {
  event({
    action,
    category,
    label,
    value
  });
};

// Función específica para CTA de la landing page
export const trackLandingPageCTA = (ctaName, section) => {
  trackCTAClick(ctaName, section);
  
  // Evento adicional para análisis más detallado
  trackEvent('landing_page_cta', 'conversion', `${section} - ${ctaName}`, 1);
};

// Función para tracking de videos de la landing page
export const trackLandingPageVideo = (videoName, section) => {
  trackVideoPlay(videoName, section);
  
  // Evento adicional para análisis más detallado
  trackEvent('landing_page_video', 'engagement', `${section} - ${videoName}`, 1);
};

// Función para tracking de scroll en la landing page
export const trackLandingPageScroll = (depth) => {
  trackScrollDepth(depth);
  
  // Evento adicional para análisis más detallado
  trackEvent('landing_page_scroll', 'engagement', `${depth}%`, depth);
};

// Función para tracking de formularios
export const trackLandingPageForm = (formName) => {
  trackFormSubmit(formName);
  
  // Evento adicional para análisis más detallado
  trackEvent('landing_page_form', 'conversion', formName, 1);
};

// Función para tracking de tiempo en página
export const trackTimeOnPage = (timeInSeconds) => {
  trackEvent('time_on_page', 'engagement', `${timeInSeconds}s`, timeInSeconds);
};

// Función para tracking de dispositivos
export const trackDeviceType = () => {
  const isMobile = window.innerWidth < 768;
  const deviceType = isMobile ? 'mobile' : 'desktop';
  
  trackEvent('device_type', 'engagement', deviceType, 1);
};

// Función para tracking de secciones vistas
export const trackSectionView = (sectionName) => {
  trackEvent('section_view', 'engagement', sectionName, 1);
};

// Función para tracking de interacciones con elementos específicos
export const trackElementInteraction = (elementName, action, section) => {
  trackEvent('element_interaction', 'engagement', `${section} - ${elementName} - ${action}`, 1);
};
